<div class="block">
  <div class="title-section {{theme}}-block-title">{{title}}</div>
  <div class="content-section">

    <ng-content></ng-content>

  </div>
</div>
